import React, { Fragment } from "react";
import { Card, CardBody, CardHeader, Col, Table } from "reactstrap";
import { H3, H5, Image, P } from "../../../AbstractElements";
import { Connections, serviceDues, serviceRequest } from "../../../Constant";
import { ActivityData } from "../../../Data/Dashboard/Default/Data";
import { Link, NavLink } from 'react-router-dom';
import moment from "moment";

const ServiceDueCard = (connections, { error }) => {


    const connectionData = [{
        key: 'tody',
        count: connections?.connections?.today,
        status: "Today",
        startDate: moment(new Date()).format("DD-MM-YYYY"),
        endDate: moment(new Date()).format("DD-MM-YYYY"),
        badge: 'warning',
        dateFilter: "today"





    }, {
        key: 'last',
        count: connections?.connections?.last_month,
        status: "Last 30 Days",
        startDate: moment().subtract(30, "days").format("DD-MM-YYYY"),
        endDate: moment().format("DD-MM-YYYY"),
        badge: 'danger',
        dateFilter: "others"


    }, {
        key: 'week',
        count: connections?.connections?.next_week,
        status: "Next week",
        startDate: moment().format("DD-MM-YYYY"),
        endDate: moment().add(7, "days").format("DD-MM-YYYY"),
        badge: 'success',
        dateFilter: "this_week"


    }]
    return (
        <Fragment>
            <Col md="6" lg="4">
                <Card className="activity-review " style={{ height: '217px' }} >
                    <CardHeader className="pb-0">
                        <H3> {serviceDues} </H3>
                    </CardHeader>
                    <CardBody>
                        {error ? (<span>{error}</span>
                        ) : (
                            <div className="table-responsive connetion-div" >
                                <Table className="table table-bordernone" >
                                    <tbody>
                                        {connectionData.map((data, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        {/* {
                                                            index === 4 && <hr className="mt-0 bg-primary" style={{ height: '2px' }} />
                                                        } */}
                                                        <div className="d-flex justify-content-between" >
                                                            <div className="" >

                                                                <NavLink to={`/service-request/service-request-dues?start_date=${data?.startDate}&end_date=${data?.endDate}&dateFilter=${data?.dateFilter}`}>
                                                                    <H5>
                                                                        {data?.status}
                                                                    </H5></NavLink>


                                                            </div>
                                                            <div className="me-3">
                                                                <P>
                                                                    <span style={{
                                                                        fontSize: '11px'
                                                                    }} className={`badge badge-${data?.badge}`}>
                                                                        {data?.count}
                                                                    </span>
                                                                </P>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody >
                                </Table>
                            </div >
                        )}


                    </CardBody>
                </Card>
            </Col>
        </Fragment >
    )
}
export default ServiceDueCard;